<template>
  <div class="loading-model">
	
    <div class="model">
	  <div class="guanbi" v-if="loadingVoice" @click="closedFn">×</div>
      <img src="../../../static/img/loading.gif" />
      <p>{{msg}}</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props:{
  	msg:String,
	loadingVoice:Boolean
  },
  mounted() {
  	console.log(this.loadingVoice)
  },
  methods:{
	  closedFn(){
		  this.$emit('func',false)
	  }
  }
};
</script>
<style lang="less">
.loading-model {
  width: 7.5rem;
  height: 100%;
  position: fixed;
  left: 50%;
  top: 0;
  z-index: 3;
  margin-left: -3.75rem;
  background: rgba(0, 0, 0, 0.4);
 // display: none;
 .guanbi{
	 width: 0.64rem;
	 height: 0.64rem;
	 font-size: 0.42rem;
	 text-align: right;
	 line-height: 0.4rem;
	 color:rgba(255,255,255,0.5);
	 position: absolute;
	 right:3%;
	 top:0%;
 }
  .model {
    width: 2rem;
    height: 2rem;
    border-radius: 0.2rem;
    background: rgba(0, 0, 0, 0.7);
    overflow: hidden;
    position: absolute;
    left: 50%;
    top: 40%;
    margin-left: -1rem;
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 0.5rem;
      height: 0.5rem;
      margin-top: 0.3rem;
    }
    p {
      font-size: 0.24rem;
      text-align: center;
      color: #fff;
      line-height: 0.8rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/loadingComponent/loading.vue